/* eslint-disable */
export default {
  forward: 'Lähetä edelleen',
  cancel: 'Peruuta',
  customNumber: 'Mukautettu numero',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"customNumber"@#@ @source: @#@"Custom number"@#@
